"use strict";

import angular from "angular";

angular.module("nucont.accounting.reportingCenter", ["nucont.shared"]);
require("./reporting-center.routes");
